import { Box, Button, TextField } from "@mui/material";
import {
  SARIconThemeColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileTextColor,
} from "../../../utility";

import {
  AddOutlined,
  DeleteOutlineOutlined,
  RemoveOutlined,
} from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import { t } from "i18next";
import axios from "axios";

const Order = ({
  order,
  currency,
  tableQr,
  tableName,
  refetch,
  handleOpenToast,
}) => {
  const [params, setParams] = useSearchParams();
  const queryClient = useQueryClient();

  const navigate = useNavigate();
  const editQuantity = async (values) => {
    const element = { ...values };
    element.token = localStorage.getItem("gustToken");
    element.menu_code = tableQr;

    const { data: response } = await axios.post(
      `${process.env.REACT_APP_API}/basket-items/${order.index}`,
      element
    );
    return response.data;
  };

  const { mutate: muteOrderQuantity, isLoading: isLoadingOrderQuantity } =
    useMutation(editQuantity, {
      onSuccess: () => {
        refetch();
      },
      onError: (res) => {
        handleOpenToast(t(res.response.data.message), false);
      },
      onSettled: () => {
        queryClient.invalidateQueries("editOrderQuantity");
      },
    });

  const editNotes = async (values) => {
    const element = { ...values };
    element.token = localStorage.getItem("gustToken");
    element.menu_code = tableQr;

    const { data: response } = await axios.post(
      `${process.env.REACT_APP_API}/basket-items/${order.index}`,
      element
    );
    return response.data;
  };

  const { mutate: muteOrderNote, isLoading: isLoadingOrder } = useMutation(
    editNotes,
    {
      onSuccess: () => {
        // handleOpenToast(t("Order has been modified successfully"), true);
        refetch();
      },
      onError: (res) => {
        handleOpenToast(t(res.response.data.message), false);
      },
      onSettled: () => {
        queryClient.invalidateQueries("editOrderNote");
      },
    }
  );

  const deleteOrder = async () => {
    const { data: response } = await axios.delete(
      `${process.env.REACT_APP_API}/basket-items/${order.index
      }?token=${localStorage.getItem("gustToken")}&menu_code=${tableQr}`
    );
    return response.data;
  };

  const { mutate: muteOrderDelete, isLoading: isLoadingDelete } = useMutation(
    deleteOrder,
    {
      onSuccess: () => {
        // handleOpenToast(t("Order has been modified successfully"), true);
        refetch();
      },
      onError: (res) => {
        handleOpenToast(t(res.response.data.message), false);
      },
      onSettled: () => {
        queryClient.invalidateQueries("deleteOrder");
      },
    }
  );

  const handleGoToItem = () => {
    navigate(
      `/${tableName}/${tableQr}/items?item=${order.id}&t=${params.get(
        "t"
      )}&selectedLang=${localStorage.getItem("lang")}`
    );
  };

  return (
    <div className="mt-4 alignByLang">
      <div className="d-flex justify-content-between sub-font">
        <p
          className="font-size-18 cursor"
          style={{ color: setMobileTextColor() }}
        >
          {`${order.name} X ${order.quantity}`}
        </p>
        <div>
          <p
            className="font-size-18 cursor"
            style={{
              color: order.price_changed ? "#F04438" : setMobileTextColor(),
            }}
          >
            {order.price} <span className="font-size-14">{currency ? currency === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : currency : ""}</span>
          </p>
          <p
            className="font-size-18 cursor"
            style={{
              color: setMobileTextColor(),
              display: order.price_changed ? "block" : "none",
            }}
          >
            {order.new_price} <span className="font-size-14">{currency ? currency === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" /> : currency : ""}</span>
          </p>
        </div>
      </div>
      <div>
        {order.automatically_generated_notes
          ?.split("//")
          .map((element, index) => (
            <p
              key={index}
              className="font-size-18 cursor sub-font"
              style={{
                color: order.price_changed ? "#F04438" : setMobileTextColor(),
              }}
            >
              {element}
            </p>
          ))}
      </div>
      {!order.is_order_option && !order?.is_combo_child && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            className="rounded-3 mx-2"
            variant="text"
            onClick={muteOrderDelete}
          >
            <DeleteOutlineOutlined
              style={{
                color:
                  localStorage.getItem("theme") === "costomize"
                    ? "#F04438"
                    : "#F04438",
              }}
              fontSize="medium"
            />
          </Button>
          <div>
            <Button
              onClick={() => {
                if (order.quantity >= 2) {
                  muteOrderQuantity({
                    quantity: order.quantity - 1,
                    notes: "",
                  });
                }
              }}
              sx={{
                height: "40px",
                minWidth: "40px",
              }}
              size="small"
            >
              <RemoveOutlined style={{ color: "#f00" }} fontSize="small" />
            </Button>
            <TextField
              id="quantity"
              name="quantity"
              type="text"
              variant="outlined"
              value={order.quantity}
              className="form-control rounded-2 sub-font"
              size="small"
              sx={{
                textAlign: "center",
                width: "60px",
                color: setMobileTextColor(),
                backgroundColor: setMobileCardColor(),
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: setMobileCardBorderColor(),
                },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: setMobileButttonBackColor(),
                },
                "& .MuiInputBase-input": {
                  color: setMobileTextColor(), // Set the text color
                  textAlign: "center",
                },
              }}
              inputprops={{
                style: {
                  color: setMobileTextColor(),
                  backgroundColor: setMobileCardColor(),
                  border: `1px solid #D0D5DD `,
                  textAlign: "center",
                },
              }}
            />
            <Button
              onClick={() => {
                if (order.quantity <= 100) {
                  muteOrderQuantity({
                    quantity: order.quantity + 1,
                    notes: "",
                  });
                }
              }}
              sx={{
                height: "40px",
                minWidth: "40px",
              }}
              size="small"
            >
              <AddOutlined
                style={{
                  color:
                    localStorage.getItem("theme") === "costomize"
                      ? setMobileButttonBackColor()
                      : setMobileTextColor(),
                }}
                fontSize="small"
              />
            </Button>
          </div>
        </Box>
      )}
      {!order.is_order_option && !order?.is_combo_child && (
        <div className="m-top-12  rounded-3">
          <TextField
            id="note"
            name="note"
            type="text"
            variant="outlined"
            defaultValue={order.notes}
            onBlur={(e) =>
              muteOrderNote({ quantity: null, notes: e.target.value })
            }
            placeholder={t("Enter your note")}
            className="form-control rounded-2 sub-font"
            size="small"
            sx={{
              minWidth: 300,
              backgroundColor: setMobileCardColor(),


              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: setMobileCardBorderColor(),
              },
              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: setMobileButttonBackColor(),
              },
              "& .MuiInputBase-input": {
                color: setMobileTextColor(),
                fontFamily:
                  localStorage.getItem("lang") === "ar" ||
                    localStorage.getItem("lang") === "fa"
                    ? "Almarai"
                    : "Roboto",
              },
            }}
            inputprops={{
              style: {
                color: setMobileTextColor(),
                backgroundColor: setMobileCardColor(),
                border: `1px solid #D0D5DD `,
              },
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Order;
